import { useState } from 'react'
import { LogIn, LogOut, User } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import Modal from '../Common/Modal'

export default function AuthPanel({ iconOnly = false }: { iconOnly?: boolean }) {
  const { user, loading, error, login, register, logout } = useAuthStore()
  const [open, setOpen] = useState(false)
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [name, setName] = useState(''), [email, setEmail] = useState(''), [password, setPassword] = useState('')

  const submit = async (event: React.FormEvent) => { event.preventDefault(); const ok = mode === 'login' ? await login(email, password) : await register(name, email, password); if (ok) setOpen(false) }

  if (iconOnly) {
    return (
      <>
        {user ? (
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-xl text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-slate-800/60 transition-all duration-200 hover:scale-110 active:scale-95 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none"
            onClick={() => logout()}
            title={`Conectado como ${user.name} (Clique para Sair)`}
            aria-label="Sair da conta"
          >
            <User size={17} />
          </button>
        ) : (
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-xl text-slate-500 hover:bg-slate-100 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800/60 dark:hover:text-slate-200 transition-all duration-200 hover:scale-110 active:scale-95 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none"
            onClick={() => setOpen(true)}
            title="Entrar ou Criar Conta"
            aria-label="Entrar ou Criar Conta"
          >
            <LogIn size={17} />
          </button>
        )}

        {open && !user && (
          <Modal title={mode === 'login' ? 'Entrar' : 'Criar conta'} onClose={() => setOpen(false)}>
            <form className="space-y-4 p-5" onSubmit={submit}>
              {mode === 'register' && <label className="field-label">Nome<input className="input mt-1" autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} /></label>}
              <label className="field-label">E-mail<input className="input mt-1" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
              <label className="field-label">Senha<input className="input mt-1" type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={15} maxLength={128} /></label>
              {mode === 'register' && <p className="text-xs text-slate-500">Use uma frase-senha com pelo menos 15 caracteres. Espaços são permitidos.</p>}
              {error && <p role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
              <button className="btn-primary flex w-full items-center justify-center gap-2" disabled={loading}>{loading ? 'Aguarde…' : mode === 'login' ? 'Entrar' : 'Criar conta'}</button>
              <button type="button" className="w-full text-sm text-blue-700 hover:underline" onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>{mode === 'login' ? 'Ainda não tenho conta' : 'Já tenho uma conta'}</button>
            </form>
          </Modal>
        )}
      </>
    )
  }

  if (user) return <div className="flex items-center gap-2"><span className="hidden md:inline text-xs text-slate-300">{user.name}</span><button className="topbar-button" onClick={() => logout()} aria-label="Sair da conta"><LogOut size={15} /><span className="hidden sm:inline">Sair</span></button></div>
  return <><button className="topbar-button" onClick={() => setOpen(true)}><LogIn size={15} /> Entrar</button>{open && <Modal title={mode === 'login' ? 'Entrar' : 'Criar conta'} onClose={() => setOpen(false)}>
    <form className="space-y-4 p-5" onSubmit={submit}>
      {mode === 'register' && <label className="field-label">Nome<input className="input mt-1" autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} /></label>}
      <label className="field-label">E-mail<input className="input mt-1" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
      <label className="field-label">Senha<input className="input mt-1" type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={15} maxLength={128} /></label>
      {mode === 'register' && <p className="text-xs text-slate-500">Use uma frase-senha com pelo menos 15 caracteres. Espaços são permitidos.</p>}
      {error && <p role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      <button className="btn-primary flex w-full items-center justify-center gap-2" disabled={loading}>{loading ? 'Aguarde…' : mode === 'login' ? 'Entrar' : 'Criar conta'}</button>
      <button type="button" className="w-full text-sm text-blue-700 hover:underline" onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>{mode === 'login' ? 'Ainda não tenho conta' : 'Já tenho uma conta'}</button>
    </form>
  </Modal>}</>
}
